import styles from "./Layout.module.scss";
import Grid from "@mui/material/Grid2";
import AppRoute from "../routes/AppRoute";
import useWindowSize from "../hooks/useWindowSize";
import { utmSourceURL } from "../lib/script";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ContextualLoader from "../components/contextualLoader";
import phone from "../assets/layout/phone.png"

export default function Layout() {
  const navigate = useNavigate();
  const { windowSize } = useWindowSize();
  const { pathname, search, state } = useLocation();

  useEffect(() => {
    if(window.parent) {
      let searchStr = search.length ? search.startsWith('?') ? search : '?'+search : '';
      window.parent.history.replaceState(state, "", pathname + searchStr);
    }
  }, [pathname, search, state]);

  useEffect(() => {
    const handlePopState  =  () => {
      let searchStr = search.length ? search.startsWith('?') ? search : '?'+search : '';
      navigate(pathname + searchStr, { replace: true })
    }
    window.parent &&  window.addEventListener("popstate", handlePopState);
    return () => {
      window.parent && window.removeEventListener("popstate", handlePopState);
    }
  }, []);


  return (
    <>
      {windowSize.width > 992 ? (
        <div className={styles.layout}>
          <div className={styles.content}>
            <div className={styles.logo}>
              <img src="/images/logo.png" alt="" />
            </div>
            <h1>
              Get Instant Personal Loans upto <span>₹8&nbsp;Lakhs</span>
            </h1>

            <Grid container spacing={2}>
              <Grid size={6}>
                <div className={styles.listItem}>
                  <img src="/images/layout/timer.png" alt="" />
                  <h4>Disburse in Few Minutes</h4>
                </div>
              </Grid>
              <Grid size={6}>
                <div className={styles.listItem}>
                  <img src="/images/layout/profile.png" alt="" />
                  <h4>For Salaried and Self Employed</h4>
                </div>
              </Grid>
              <Grid size={6}>
                <div className={styles.listItem}>
                  <img src="/images/layout/note.png" alt="" />
                  <h4>100% Paperless Documentation </h4>
                </div>
              </Grid>
              <Grid size={6}>
                <div className={styles.listItem}>
                  <img src="/images/layout/music-play.png" alt="" />
                  <h4>24/7 Customer Support</h4>
                </div>
              </Grid>
              <Grid size={6}>
                <div className={styles.listItem}>
                  <img src="/images/layout/math.png" alt="" />
                  <h4>Flexible Repayment Options</h4>
                </div>
              </Grid>
              <Grid size={6}>
                <div className={styles.listItem}>
                  <img src="/images/layout/rating-star.png" alt="" />
                  <h4>100k+ Satisfied User</h4>
                </div>
              </Grid>
            </Grid>

            <div className={styles.reviews}>
              <img src="/images/layout/rating.png" alt="" />
            </div>
          </div>
          <div className={styles.screen}>
            <div
              className={styles.frame}
            >
              <div className={styles.bgMobile}>
                <div className={styles.bg} />
                <img src={phone} alt="" />
              </div>

              <iframe
                id="jouneryFrame"
                src={`${window.location?.href}${utmSourceURL()}`}
                title=""
                style={{ border: "none", scrollbarWidth: "none" }}
              ></iframe>
               <ContextualLoader />
            </div>
            <div style={{height: "30px"}} />
            {/* above empty div is required for bottom space */}
          </div>
        </div>
      ) : (
        <>
          <AppRoute />
          {/* <BottomTabs /> */}
           <ContextualLoader />
        </>
      )}
    </>
  );
}
